import React from 'react';
import ServicePageLayout, { FeatureGrid, ServiceCTA } from './ServicePageLayout';
import { getService } from './serviceData';

const service = getService('software-web-development');

const buildFeatures = [
  { title: 'Custom Software', desc: 'Bespoke internal tools and business systems engineered around how you actually work.' },
  { title: 'SaaS Development', desc: 'Multi-tenant SaaS platforms with billing, auth, and dashboards, built to scale.' },
  { title: 'Mobile Apps (iOS & Android)', desc: 'Native-quality mobile experiences for both major platforms from a single roadmap.' },
  { title: 'Website Development', desc: 'Fast, responsive marketing sites and web apps with modern, accessible front-ends.' },
  { title: 'E-Commerce Platforms', desc: 'Storefronts, checkout, and payment flows tuned for conversion and reliability.' },
  { title: 'Web Hosting', desc: 'Managed hosting and deployment so your software stays online and up to date.' },
];

const stack = ['Python', 'Node.js', 'React', 'JavaScript', 'HTML & CSS', 'Agile Methodology'];

const SoftwareWebDevelopment = () => (
  <ServicePageLayout service={service} h1="Custom Software & Web Development">
    <p className="service-intro">
      Tavernix designs and builds software for modern businesses, from founders shipping their
      first SaaS to established companies modernizing legacy systems. We handle the full lifecycle:
      product strategy, design, engineering, and the hosting it runs on.
    </p>

    <FeatureGrid heading="What We Build" features={buildFeatures} />

    <section className="service-section">
      <h2>Our Tech Stack</h2>
      <p className="service-intro">
        We ship with proven, well-supported tools and an Agile delivery process, so you get working
        software early and often.
      </p>
      <ul className="service-stack-list">
        {stack.map((tech) => (
          <li key={tech}>{tech}</li>
        ))}
      </ul>
    </section>

    <ServiceCTA
      heading="Have something to build?"
      blurb="Tell us what you need and we'll scope it with you."
      label="Start a Project"
      href="mailto:info@tavernix.io?subject=Start%20a%20Project%20%E2%80%94%20Software%20%26%20Web%20Development"
    />
  </ServicePageLayout>
);

export default SoftwareWebDevelopment;
